import { render, staticRenderFns } from "./IconPhoneRetro.vue?vue&type=template&id=329b4485&"
import script from "./IconPhoneRetro.vue?vue&type=script&lang=ts&"
export * from "./IconPhoneRetro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports